import { XIcon } from 'lucide-react';

export default function CloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="absolute top-2 right-2 opacity-70 transition-opacity hover:opacity-100"
      aria-label="Close feedback popup"
    >
      <XIcon className="h-4 w-4" />
      <span className="sr-only">Close</span>
    </button>
  );
}
